export const method = {
    labels: {},
    texts: {
        add_method: "Adicionar Método",
        edit_method: "Editar Método",
        del_method: "Excluir Método",
        del_field: "Excluir Campo",
        del_field_confirm: "Você deseja excluir o campo <strong>'{concat}'</strong>?",
        del_confirm: "Você deseja excluir o método <strong>'{concat}'</strong>?",
        del_question_confirm: "Você deseja excluir a questão <strong>'{concat}'</strong>?",
    },
};
